// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3319":"cebb2e9f","4990":"b0ae644f","7534":"3f8034d7","8278":"b0ae644f"}[chunkId] + ".chunk.css";
};